import { hasPermission } from './permissions';
import { matchPath } from 'react-router-dom';

// Migrated modules use API permissions. Remaining modules retain their legacy role rules.
export const canAccessRoute = (user, route) => {
  if (!route) return false;
  if (route.access === 'public') return true;
  if (route.access === 'guest') return !user;
  if (!user) return false;
  if (route.permission) return hasPermission(user, route.permission);
  return route.roles === null || route.roles.includes(user.role);
};

export const canAccessPath = (user, path, routes) => {
  const pathname = path.startsWith('/') ? path : `/${path}`;
  const route = routes.find(
    (entry) =>
      entry.path !== '*' &&
      matchPath({ path: entry.path, end: true }, pathname),
  );
  return canAccessRoute(user, route);
};

export const filterNavigation = (items, user, routes) =>
  items.flatMap((item) => {
    if (item.children) {
      const children = filterNavigation(item.children, user, routes);
      return children.length ? [{ ...item, children }] : [];
    }
    return canAccessPath(user, item.href, routes) ? [item] : [];
  });
